import { copy as productCopy } from "../../server/copy";
import { object, parseDraft, parseSummary, parseViewer, type DraftRecord, type DraftSummary, type Viewer } from "./core/workspace";
export class ApiError extends Error {
  constructor(readonly status: number, readonly payload: unknown) {
    const row = object(payload);
    super(typeof row?.error === "string" ? row.error : typeof row?.message === "string" ? row.message : productCopy.requestFailed);
  }
}
export async function api(path: string, method = "GET", value?: unknown, signal?: AbortSignal): Promise<unknown> {
  const response = await fetch(path, { method, headers: value === undefined ? {} : { "Content-Type": "application/json" },
    ...(value === undefined ? {} : { body: JSON.stringify(value) }), ...(signal === undefined ? {} : { signal }) });
  const result: unknown = await response.json().catch(() => null);
  if (!response.ok) throw new ApiError(response.status, result);
  return result;
}
export async function me(): Promise<Viewer> {
  const result = parseViewer(await api("/api/me"));
  if (!result) throw new Error("Invalid account response");
  return result;
}
export async function listDrafts(offset = 0, fingerprint?: string): Promise<DraftSummary[]> {
  const query = new URLSearchParams({ offset: String(offset), ...(fingerprint === undefined ? {} : { fingerprint }) });
  const result = await api(`/api/drafts?${query}`);
  if (!Array.isArray(result)) throw new Error("Invalid project list");
  return result.map((row: unknown) => { const checked = parseSummary(row); if (!checked) throw new Error("Invalid project summary"); return checked; });
}
export function checkedDraft(value: unknown): DraftRecord {
  const checked = parseDraft(value);
  if (!checked) throw new Error("Invalid project response");
  return checked;
}
export async function fetchDraft(id: string): Promise<DraftRecord> { return checkedDraft(await api(`/api/drafts/${id}`)); }
export async function createDraft(id: string, title: string, fingerprint: string, document: DraftRecord["document"]): Promise<DraftRecord> {
  return checkedDraft(await api("/api/drafts", "POST", { id, title, fingerprint, document }));
}
